import React from 'react';
import { RegisterUser } from '../Components/Register/register';
import { LoginYt } from '../Components/Login/login';
import { useState } from 'react';


export function Login() { 

  //view === 0 is login view
  //view === 1 is register view

  const [view, setView] = useState(0)
    return (
      <>  
       {!view ? 
       <>
       <LoginYt />
       </>
        : 
        <>
        <RegisterUser />
        </>}
      </>
);
   };

